import { render, staticRenderFns } from "./EbLabel.vue?vue&type=template&id=43d05d98&scoped=true"
import script from "./EbLabel.vue?vue&type=script&lang=js"
export * from "./EbLabel.vue?vue&type=script&lang=js"
import style0 from "./EbLabel.vue?vue&type=style&index=0&id=43d05d98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d05d98",
  null
  
)

export default component.exports